import * as React from 'react';
import Skeleton from '@mui/material/Skeleton';
import { Grid } from '@mui/material';

export default function PermissionSkeleton() {
  return (
    <Grid container p={4} spacing={2}>
      <Grid item xs={12} sm={4} container spacing={2} p={5}>
        < Grid item xs={12}>
          <Skeleton variant="text" ></Skeleton>
        </Grid>
        <Grid item xs={12}>
          <Skeleton variant="text" ></Skeleton>
        </Grid>
        <Grid item xs={12}>
          <Skeleton variant="text" ></Skeleton>
        </Grid>
        <Grid item xs={12}>
          <Skeleton variant="text" ></Skeleton>
        </Grid>
        <Grid item xs={12}>
          <Skeleton variant="text" ></Skeleton>
        </Grid>
      </Grid>
      <Grid item xs={12} sm={4} container spacing={1} p={5}>
        < Grid item xs={12}>
          <Skeleton variant="text" ></Skeleton>
        </Grid>
        <Grid item xs={12}>
          <Skeleton variant="text" ></Skeleton>
        </Grid>
        <Grid item xs={12}>
          <Skeleton variant="text" ></Skeleton>
        </Grid>
        <Grid item xs={12}>
          <Skeleton variant="text" ></Skeleton>
        </Grid>
        <Grid item xs={12}>
          <Skeleton variant="text" ></Skeleton>
        </Grid>
      </Grid>
      <Grid item xs={12} sm={4} container spacing={1} p={5}>
        < Grid item xs={12}>
          <Skeleton variant="text" ></Skeleton>
        </Grid>
        <Grid item xs={12}>
          <Skeleton variant="text" ></Skeleton>
        </Grid>
        <Grid item xs={12}>
          <Skeleton variant="text" ></Skeleton>
        </Grid>
        <Grid item xs={12}>
          <Skeleton variant="text" ></Skeleton>
        </Grid>
        <Grid item xs={12}>
          <Skeleton variant="text" ></Skeleton>
        </Grid>
      </Grid>
      <Grid item xs={12} sm={4} container spacing={2} p={5}>
        < Grid item xs={12}>
          <Skeleton variant="text" ></Skeleton>
        </Grid>
        <Grid item xs={12}>
          <Skeleton variant="text" ></Skeleton>
        </Grid>
        <Grid item xs={12}>
          <Skeleton variant="text" ></Skeleton>
        </Grid>
        <Grid item xs={12}>
          <Skeleton variant="text" ></Skeleton>
        </Grid>
        <Grid item xs={12}>
          <Skeleton variant="text" ></Skeleton>
        </Grid>
      </Grid>
      <Grid item xs={12} sm={4} container spacing={2} p={5}>
        < Grid item xs={12}>
          <Skeleton variant="text" ></Skeleton>
        </Grid>
        <Grid item xs={12}>
          <Skeleton variant="text" ></Skeleton>
        </Grid>
        <Grid item xs={12}>
          <Skeleton variant="text" ></Skeleton>
        </Grid>
        <Grid item xs={12}>
          <Skeleton variant="text" ></Skeleton>
        </Grid>
        <Grid item xs={12}>
          <Skeleton variant="text" ></Skeleton>
        </Grid>
      </Grid>
      <Grid item xs={12} sm={4} container spacing={2} p={5}>
        < Grid item xs={12}>
          <Skeleton variant="text" ></Skeleton>
        </Grid>
        <Grid item xs={12}>
          <Skeleton variant="text" ></Skeleton>
        </Grid>
        <Grid item xs={12}>
          <Skeleton variant="text" ></Skeleton>
        </Grid>
        <Grid item xs={12}>
          <Skeleton variant="text" ></Skeleton>
        </Grid>
        <Grid item xs={12}>
          <Skeleton variant="text" ></Skeleton>
        </Grid>
      </Grid>
      <Grid item xs={12} sm={4} container spacing={2} p={5}>
        < Grid item xs={12}>
          <Skeleton variant="text" ></Skeleton>
        </Grid>
        <Grid item xs={12}>
          <Skeleton variant="text" ></Skeleton>
        </Grid>
        <Grid item xs={12}>
          <Skeleton variant="text" ></Skeleton>
        </Grid>
        <Grid item xs={12}>
          <Skeleton variant="text" ></Skeleton>
        </Grid>
        <Grid item xs={12}>
          <Skeleton variant="text" ></Skeleton>
        </Grid>
      </Grid>
      <Grid item xs={12} sm={4} container spacing={2} p={5}>
        < Grid item xs={12}>
          <Skeleton variant="text" ></Skeleton>
        </Grid>
        <Grid item xs={12}>
          <Skeleton variant="text" ></Skeleton>
        </Grid>
        <Grid item xs={12}>
          <Skeleton variant="text" ></Skeleton>
        </Grid>
        <Grid item xs={12}>
          <Skeleton variant="text" ></Skeleton>
        </Grid>
        <Grid item xs={12}>
          <Skeleton variant="text" ></Skeleton>
        </Grid>
      </Grid>
      <Grid item xs={12} sm={4} container spacing={2} p={5}>
        < Grid item xs={12}>
          <Skeleton variant="text" ></Skeleton>
        </Grid>
        <Grid item xs={12}>
          <Skeleton variant="text" ></Skeleton>
        </Grid>
        <Grid item xs={12}>
          <Skeleton variant="text" ></Skeleton>
        </Grid>
        <Grid item xs={12}>
          <Skeleton variant="text" ></Skeleton>
        </Grid>
        <Grid item xs={12}>
          <Skeleton variant="text" ></Skeleton>
        </Grid>
      </Grid>
    </Grid >
  );
}